import axios from 'axios';

axios.defaults.baseURL = '/api/v1';
axios.defaults.headers.common['X-CSRF-Token'] = getToken();

function getToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta && meta.getAttribute('content');
}
